import { render, staticRenderFns } from "./File_Upload.vue?vue&type=template&id=ada55210&scoped=true&"
import script from "./File_Upload.vue?vue&type=script&lang=js&"
export * from "./File_Upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ada55210",
  null
  
)

export default component.exports